/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1LockIcon16Light } from './People1LockIcon16Light';
import { People1LockIcon16Regular } from './People1LockIcon16Regular';
import { People1LockIcon16Solid } from './People1LockIcon16Solid';
import { People1LockIcon20Light } from './People1LockIcon20Light';
import { People1LockIcon20Regular } from './People1LockIcon20Regular';
import { People1LockIcon20Solid } from './People1LockIcon20Solid';
import { People1LockIcon24Regular } from './People1LockIcon24Regular';
import { People1LockIcon24Solid } from './People1LockIcon24Solid';
import { People1LockIcon32Regular } from './People1LockIcon32Regular';
import { People1LockIcon64Regular } from './People1LockIcon64Regular';
var sizes = {
    16: {
        light: People1LockIcon16Light,
        regular: People1LockIcon16Regular,
        solid: People1LockIcon16Solid,
    },
    20: {
        light: People1LockIcon20Light,
        regular: People1LockIcon20Regular,
        solid: People1LockIcon20Solid,
    },
    24: {
        regular: People1LockIcon24Regular,
        solid: People1LockIcon24Solid,
    },
    32: {
        regular: People1LockIcon32Regular,
    },
    64: {
        regular: People1LockIcon64Regular,
    },
};
export var People1LockIcon = forwardRef('People1LockIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
